<template>
	<div class="overview-container">
		<!-- Candidate Info Section -->
		<div
			v-if="
				(candidate.current_company && candidate.current_company.length > 0) ||
				candidate.country_code ||
				(candidate.city && candidate.city.length > 0) ||
				(candidate.county && candidate.county.length > 0) ||
				(candidate.identification_number && candidate.identification_number.length > 0) ||
				candidate.birth_date ||
				(candidate.last_school && candidate.last_school.length > 0) ||
				(candidate.tags && candidate.tags.length > 0) ||
				(candidate.total_years_experience &&
					candidate.total_years_experience > 0) ||
				(candidate.work_experience && candidate.work_experience.length > 0) ||
				(candidate.education && candidate.education.length > 0)
			"
			class="candidate-info-section"
		>
			<v-list class="candidate-info-list">
				<v-list-item
					two-line
					v-if="
						candidate.current_company && candidate.current_company.length > 0
					"
				>
					<v-list-item-icon>
						<v-icon>business</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-subtitle>{{
							$t('label.current-company')
						}}</v-list-item-subtitle>
						<v-list-item-title>{{
							candidate.current_company
						}}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					two-line
					v-if="candidate.country_code && countryName"
				>
					<v-list-item-icon>
						<v-icon>public</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-subtitle>{{
							$t('label.country')
						}}</v-list-item-subtitle>
						<v-list-item-title>{{
							countryName
						}}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					two-line
					v-if="candidate.city && candidate.city.length > 0"
				>
					<v-list-item-icon>
						<v-icon>location_city</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-subtitle>{{
							$t('label.city')
						}}</v-list-item-subtitle>
						<v-list-item-title>{{
							toLocaleCapitalize(candidate.city, 'tr')
						}}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					two-line
					v-if="candidate.county && candidate.county.length > 0"
				>
					<v-list-item-icon>
						<v-icon>map</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-subtitle>{{
						$t('label.county')
						}}</v-list-item-subtitle>
						<v-list-item-title>{{
							toLocaleCapitalize(candidate.county, 'tr')
						}}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					two-line
					v-if="candidate.identification_number && candidate.identification_number.length > 0"
				>
					<v-list-item-icon>
						<v-icon>badge</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-subtitle>{{
							$t('label.tckn')
						}}</v-list-item-subtitle>
						<v-list-item-title>{{
							candidate.identification_number
						}}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					two-line
					v-if="candidate.birth_date"
				>
					<v-list-item-icon>
						<v-icon>cake</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-subtitle>{{
							$t('label.birth-date')
						}}</v-list-item-subtitle>
						<v-list-item-title>{{
							formatDate({
								timestamp: candidate.birth_date,
								format: 'dd.MM.yyyy'
							})
						}}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				
				<v-list-item
					two-line
					v-if="candidate.last_school && candidate.last_school.length > 0"
				>
					<v-list-item-icon>
						<v-icon>school</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-subtitle class="overview-subtitle">{{
							toLocaleCapitalize($t('label.last-school-attended'), locale)
						}}</v-list-item-subtitle>
						<v-list-item-title>{{ candidate.last_school }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					two-line
					v-if="candidate.tags && candidate.tags.length > 0"
				>
					<v-list-item-icon>
						<v-icon>label</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-subtitle>{{ toLocaleCapitalize($t('label.tags'), locale) }}</v-list-item-subtitle>
						<v-list-item-title>
							<ChipEditor v-model="candidate.tags"></ChipEditor>
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					v-if="
						candidate.total_years_experience &&
						candidate.total_years_experience > 0
					"
				>
					<v-list-item-icon>
						<v-icon>timer</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-subtitle>{{
							toLocaleCapitalize($t('label.total-years-experience'), locale)
						}}</v-list-item-subtitle>
						<v-list-item-title>
							{{ candidate.total_years_experience }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

			 	<v-list-item
					two-line
					v-if="
						((candidate.work_experience &&
							candidate.work_experience.length > 0) ||
							profileEditHistory.work_experience.length > 0) &&
						showMore
					"
				>
					<v-list-item-icon>
						<v-icon>business</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<fieldset class="talentics-fieldset talentics-fieldset-paddings">
							<legend>
								{{ $t('label.work-experience') }}
								<v-tooltip
									bottom
									v-if="profileEditHistory.work_experience.length > 0"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											x-small
											icon
											color="warning"
											v-bind="attrs"
											v-on="on"
											@click="openEditHistory('work_experience')"
										>
											<v-icon small>history</v-icon>
										</v-btn>
									</template>
									<span>{{ $t('label.edited-by-user') }}</span>
								</v-tooltip>
							</legend>
							<v-row
								v-for="(
									work_experience_item, index
								) in candidate.work_experience"
								:key="`workExperience_${index}`"
							>
								<v-col cols="12">
									<div style="font-weight: 700">
										{{ work_experience_item.job_title }}
									</div>
									<div>
										{{ work_experience_item.organization }}
									</div>
									<div
										style="font-size: 0.75rem"
										v-if="
											work_experience_item.start_date ||
											work_experience_item.end_date
										"
									>
										<span>{{
											work_experience_item.start_date
												? formatDate({
														timestamp: work_experience_item.start_date,
														format: 'MMM yyyy',
												  })
												: ''
										}}</span>
										<span> - </span>
										<span>
											<span v-if="work_experience_item.is_current">
												Present
											</span>
											<span v-else>
												{{
													work_experience_item.end_date
														? formatDate({
																timestamp: work_experience_item.end_date,
																format: 'MMM yyyy',
														  })
														: ''
												}}
											</span>
										</span>
									</div>
									<div>
										{{ work_experience_item.job_description }}
									</div>
								</v-col>
								<v-col
									cols="12"
									v-if="index < candidate.work_experience.length - 1"
								>
									<v-divider></v-divider>
								</v-col>
							</v-row>
						</fieldset>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					two-line
					v-if="
						((candidate.education && candidate.education.length > 0) ||
							profileEditHistory.education.length > 0) &&
						showMore
					"
				>
					<v-list-item-icon>
						<v-icon>school</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<fieldset class="talentics-fieldset talentics-fieldset-paddings">
							<legend>
								{{ $t('label.education') }}
								<v-tooltip
									bottom
									v-if="profileEditHistory.education.length > 0"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											x-small
											icon
											color="warning"
											v-bind="attrs"
											v-on="on"
											@click="openEditHistory('education')"
										>
											<v-icon small>history</v-icon>
										</v-btn>
									</template>
									<span>{{ $t('label.edited-by-user') }}</span>
								</v-tooltip>
							</legend>
							<v-row
								v-for="(educationItem, index) in candidate.education"
								:key="`education_${index}`"
							>
								<v-col cols="12">
									<div style="font-weight: 700">
										{{ educationItem.organization }}
									</div>
									<div>{{ educationItem.education }}</div>
									<div
										style="font-size: 0.75rem"
										v-if="educationItem.start_date || educationItem.end_date"
									>
										<span>{{
											educationItem.start_date
												? formatDate({
														timestamp: educationItem.start_date,
														format: 'MMM yyyy',
												  })
												: ''
										}}</span>
										<span> - </span>
										<span>{{
											educationItem.end_date
												? formatDate({
														timestamp: educationItem.end_date,
														format: 'MMM yyyy',
												  })
												: ''
										}}</span>
									</div>
								</v-col>
								<v-col cols="12" v-if="index < candidate.education.length - 1">
									<v-divider></v-divider>
								</v-col>
							</v-row>
						</fieldset>
					</v-list-item-content>
				</v-list-item>

				<ProfileEditHistoryDialog
					v-if="editHistoryDialog.visible"
					:section="editHistoryDialog.section"
					:items="profileEditHistory[editHistoryDialog.section]"
					:onClose="closeEditHistory"
				></ProfileEditHistoryDialog>

				<v-list-item
					v-if="
						(candidate.work_experience &&
							candidate.work_experience.length > 0) ||
						(candidate.education && candidate.education.length > 0) ||
						profileEditHistory.education.length > 0 ||
						profileEditHistory.work_experience.length > 0
					"
				>
					<v-list-item-icon> </v-list-item-icon>
					<v-list-item-content>
						<v-btn small @click="showMore = true" v-if="!showMore">
							<v-icon left>expand_more</v-icon>
							{{ $t('button.more') }}
						</v-btn>
						<v-btn small @click="showMore = false" v-else>
							<v-icon left>expand_less</v-icon>
							{{ $t('button.less') }}
						</v-btn>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</div>

		<!-- Action Buttons Section -->
		<div class="action-buttons-section">
			<NewJobMenu :candidateId="candidate.id"></NewJobMenu>
			<v-tooltip
				v-if="currentUser && currentUser.can_schedule_calendar_events && company?.package_type?.features?.is_interview_scheduling_enabled === false"
				top
			>
				<template v-slot:activator="{ on, attrs }">
					<div v-bind="attrs" v-on="on" style="display: inline">
						<v-btn
							small
							class="action-btn"
							@click="handleScheduleCandidateDialogOpen"
							:disabled="true"
						>
							<v-icon left>event</v-icon>
							{{ $t('button.schedule-interview') }}
							<v-icon
								small
								class="ml-1"
								color="grey"
							>
								lock
							</v-icon>
						</v-btn>
					</div>
				</template>
				{{ $t('tooltip.feature-not-available-in-package') }}
			</v-tooltip>
			<v-btn
				v-else-if="currentUser && currentUser.can_schedule_calendar_events"
				small
				class="action-btn"
				@click="handleScheduleCandidateDialogOpen"
			>
				<v-icon left>event</v-icon>
				{{ $t('button.schedule-interview') }}
			</v-btn>
			<ScheduleEmailMenu
				:candidate="candidate"
				:onStart="handleScheduleNewEmail"
				buttonIcon="email"
			></ScheduleEmailMenu>
			<v-btn
				small
				class="action-btn"
				@click="handleSendOfferClick"
				v-if="company.id === 8 && currentUser.can_create_offer_requisitions"
			>
				<v-icon left>receipt_long</v-icon>
				{{ $t('button.send-offer') }}
			</v-btn>
		</div>

		<!-- Applications Section Header -->
		<div class="applications-section-header">
			<v-icon class="section-header-icon">work_outline</v-icon>
			<span class="section-header-title">{{ toLocaleCapitalize($t('subheader.applied-jobs'), locale) }}</span>
			<span class="section-header-count">({{ candidate.applications ? candidate.applications.length : 0 }})</span>
		</div>

		<!-- Application Cards -->
		<div class="applications-list">
			<v-card
				v-for="(application, i) in candidate.applications"
				:key="`application_${i}`"
				class="application-card"
				outlined
			>
				<!-- Card Header -->
				<div class="application-card-header">
					<div class="application-card-header-left">
						<Avatar
							:userId="application.owner"
							:tooltipAppend="`${$t('label.posting-owner')}: `"
							class="application-avatar"
						></Avatar>
						<div class="application-title-section">
							<div class="application-title-row">
								<h3 class="application-job-title">
									{{ getJobName({ jobId: application.job_id }) }}
									<span v-if="application.score" class="application-legacy-score">
										({{ parseInt(application.score * 100) }}%)
									</span>
								</h3>
								<EditJobMenu
									:candidateId="candidate.id"
									:jobId="application.job_id"
									:applicationId="application.id"
									:refName="`edit_candidate_job_${i}_form`"
								></EditJobMenu>
							</div>
							
							<!-- Application Meta -->
							<div class="application-meta">
								<span class="meta-item">
									<v-icon x-small class="meta-icon">event</v-icon>
									{{ formatDate({ timestamp: application.created }) }}
								</span>
								<span v-if="application.source" class="meta-item">
									<v-icon x-small class="meta-icon">link</v-icon>
									{{ application.source }}
								</span>
								<span v-if="application.identifier" class="meta-item meta-identifier">
									<v-icon x-small class="meta-icon">tag</v-icon>
									{{ application.identifier }}
								</span>
							</div>
						</div>
					</div>
					
					<div class="application-card-header-right">
						<!-- Fill Position Button (only shown when hired) -->
						<FillPosition
							:jobId="application.job_id"
							:candidate="candidate"
							:application="application"
							class="fill-position-header"
						></FillPosition>
						
						<EditApplicationStatus
							:value="handleGetApplicationStatus(application)"
							:application-id="application.id"
							:job-id="application.job_id"
							:candidate-id="candidate.id"
							:is-lead="application.is_lead"
							:is-interview="application.is_interview"
							:is-archived="application.is_archived"
							:on-archive="onArchiveCandidateDialogOpen"
							:candidate="candidate"
							@change="handleApplicationStatusChange"
						></EditApplicationStatus>
					</div>
				</div>

				<!-- Card Body -->
				<div class="application-card-body">
					<!-- AI Score Section -->
					<div 
						v-if="application.ai_score !== null && application.ai_score !== undefined" 
						class="application-section ai-score-section"
					>
						<div class="ai-score-compact">
							<v-chip
								:color="getScoreColor(application.ai_score)"
								text-color="white"
								small
								class="ai-score-chip"
							>
								<v-icon left small>psychology</v-icon>
								{{ $t('label.ai-match') }}: {{ Math.round(application.ai_score) }}%
							</v-chip>
							
							<v-tooltip top max-width="300px">
								<template v-slot:activator="{ on, attrs }">
									<v-icon
										v-bind="attrs"
										v-on="on"
										small
										class="ai-score-info"
									>
										info_outline
									</v-icon>
								</template>
								<span>{{ $t('label.ai-score-explanation-tooltip') }}</span>
							</v-tooltip>
							
							<v-btn
								x-small
								text
								color="primary"
								@click="toggleScoreBreakdown(application.id)"
								class="ai-score-toggle"
							>
								<v-icon x-small left>{{ application.showBreakdown ? 'expand_less' : 'expand_more' }}</v-icon>
								{{ application.showBreakdown ? $t('label.hide-details') : $t('label.view-details') }}
							</v-btn>
						</div>
						
						<!-- Score Breakdown (expandable) -->
						<v-expand-transition>
							<div v-if="application.showBreakdown && application.ai_score_breakdown" class="ai-score-breakdown-compact">
								<div 
									v-for="(category, key) in application.ai_score_breakdown"
									:key="key"
									class="breakdown-row"
								>
									<div class="breakdown-row-header">
										<span class="breakdown-row-name">{{ formatCategoryName(key) }}</span>
										<span class="breakdown-row-score" :class="getScoreClass(category.score)">
											{{ Math.round(category.score) }}%
										</span>
									</div>
									<v-progress-linear
										:value="category.score"
										:color="getScoreColor(category.score)"
										height="4"
										rounded
										class="breakdown-row-progress"
									></v-progress-linear>
									<div v-if="category.reasoning" class="breakdown-row-reasoning">
										{{ getLocalizedReasoning(category.reasoning) }}
									</div>
								</div>
								
								<div class="breakdown-footer-compact">
									<v-icon x-small class="mr-1">info_outline</v-icon>
									{{ $t('label.ai-score-explanation') }}
								</div>
							</div>
						</v-expand-transition>
					</div>

					<!-- Manual AI scoring trigger (un-scored applications) -->
					<div
						v-if="application.ai_score === null || application.ai_score === undefined"
						class="application-section ai-score-section"
					>
						<!-- Scoring needs a job description to compare against; disable it
						for database/lead candidates whose job has none, and explain why. -->
						<v-tooltip top max-width="280px" :disabled="application.can_ai_score !== false">
							<template v-slot:activator="{ on, attrs }">
								<span v-bind="attrs" v-on="on">
									<v-btn
										small
										outlined
										color="primary"
										:disabled="application.can_ai_score === false"
										@click="openScoreDialog(application)"
									>
										<v-icon left small>psychology</v-icon>
										{{ $t('label.run-ai-score') }}
									</v-btn>
								</span>
							</template>
							<span>{{ $t('label.ai-score-disabled-no-job-description') }}</span>
						</v-tooltip>
					</div>

					<!-- Feedbacks Section -->
					<div
						v-if="
							(application.feedbacks && application.feedbacks.length > 0) ||
							(application.scorecards && application.scorecards.length > 0)
						"
						class="application-section feedbacks-section"
					>
						<div class="section-subheader">{{ $t('subheader.received-feedbacks') }}</div>
						<div class="feedbacks-content">
							<CandidateFeedbackIcons
								:feedbacks="
									application.feedbacks && application.feedbacks.length > 0
										? application.feedbacks
										: []
								"
								:scorecards="
									application.scorecards &&
									application.scorecards.length > 0
										? application.scorecards
										: []
								"
								:onClickItem="onGoToFeedbacks"
							></CandidateFeedbackIcons>
						</div>
					</div>

					<!-- Cover Letter Section -->
					<div
						v-if="application.cover_letter && application.cover_letter.length > 0"
						class="application-section cover-letter-section"
					>
						<div class="section-subheader">{{ $t('label.cover-letter') }}</div>
						<div class="cover-letter-wrapper">
							<div
								class="cover-letter-content"
								:class="{ 'cover-letter-collapsed': !application.showFullCoverLetter }"
								v-html="sanitize(application.cover_letter)"
							></div>
							<div 
								v-if="application.cover_letter.length > 200"
								class="cover-letter-toggle"
							>
								<v-btn
									x-small
									text
									color="primary"
									@click="toggleCoverLetter(application.id)"
								>
									<v-icon small left>{{ application.showFullCoverLetter ? 'expand_less' : 'expand_more' }}</v-icon>
									{{ application.showFullCoverLetter ? $t('button.show-less') : $t('button.read-more') }}
								</v-btn>
							</div>
						</div>
					</div>

					<!-- Additional Questions Section -->
					<div
						v-if="application.link_questions && application.link_questions.length > 0"
						class="application-section questions-section"
					>
						<div class="questions-content">
							<AdditionalQuestions
								:questionSet="application.link_questions_set"
								:answerSet="application.link_questions"
							></AdditionalQuestions>
						</div>
					</div>

					<!-- Pipeline Durations (hidden for now) -->
					<div v-if="false" class="application-section">
						<v-btn
							small
							@click="() => handleTogglePipelineDurations({ application_id: application.id })"
						>
							<v-icon left>pending</v-icon>
							{{ $t('label.pipeline-durations') }}
							<v-icon right>
								{{ application.is_pipeline_durations_visible ? 'arrow_drop_down' : 'arrow_right' }}
							</v-icon>
						</v-btn>
						<div v-if="application.is_pipeline_durations_visible" class="mt-2">
							<PipelineDurations
								:applicationId="application.id"
								:candidateId="candidate.id"
							></PipelineDurations>
						</div>
					</div>

					<!-- Interviews Section -->
					<div 
						v-if="application.events && application.events.length > 0"
						class="application-section interviews-section"
					>
						<v-btn
							small
							outlined
							@click="handleToggleInterviews"
							class="interviews-toggle-btn"
						>
							<v-icon left>event</v-icon>
							{{ $t('label.interviews') }} ({{ application.events.length }})
							<v-icon right>
								{{ isInterviewsCardVisible ? 'expand_less' : 'expand_more' }}
							</v-icon>
						</v-btn>
						
						<v-expand-transition>
							<v-card v-if="isInterviewsCardVisible" flat class="interviews-card">
								<div
									v-for="(item, index) in application.events"
									:key="`interview_${index}`"
									class="interview-item"
									:class="{ 'interview-item--cancelled': isInterviewCancelled(item) }"
								>
									<div class="interview-datetime d-flex align-center justify-space-between">
										<strong>
											{{ formatDate({ timestamp: item.start_datetime, format: 'dd.MM.yyyy' }) }}
											{{ formatDate({ timestamp: item.start_datetime, format: 'HH:mm' }) }}
											-
											{{ formatDate({ timestamp: item.end_datetime, format: 'HH:mm' }) }}
										</strong>
										<div
											v-if="canManageInterview(item) && !isReadOnlyUser"
											class="interview-actions"
										>
											<v-chip
												v-if="isInterviewCancelled(item)"
												x-small
												color="grey lighten-2"
											>
												{{ $t('text.cancelled') }}
											</v-chip>
											<template v-else>
												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-btn
															icon
															x-small
															v-on="on"
															@click="handleEditInterviewOpen({ item })"
														>
															<v-icon x-small>edit</v-icon>
														</v-btn>
													</template>
													<span>{{ $t('button.edit-interview') }}</span>
												</v-tooltip>
												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-btn
															icon
															x-small
															v-on="on"
															@click="handleCancelInterviewOpen({ item })"
														>
															<v-icon x-small>event_busy</v-icon>
														</v-btn>
													</template>
													<span>{{ $t('button.cancel-interview') }}</span>
												</v-tooltip>
											</template>
										</div>
									</div>
									<div class="interview-summary">{{ item.summary }}</div>
									<div class="interview-interviewers">
										<UserChips :userIds="item.interviewers"></UserChips>
									</div>
									<v-divider
										v-if="index < application.events.length - 1"
										class="interview-divider"
									></v-divider>
								</div>
							</v-card>
						</v-expand-transition>
					</div>

					<!-- Hired Info Section -->
					<div
						v-if="application.hired_info && application.hired_info.length > 0"
						class="application-section hired-info-section"
					>
						<div
							v-for="(item, index) in application.hired_info"
							:key="`hired_info_${index}`"
						>
							<fieldset class="talentics-fieldset talentics-fieldset-paddings">
								<legend>{{ $t('label.hiree-info') }}</legend>
								<div class="hired-info-content">
									<label class="v-label v-label--active hired-info-label">
										{{ $t('label.time-to-hire') }}
									</label>
									<div class="hired-info-value">{{ item.time_to_hire }} days</div>
								</div>
								<v-divider class="my-2"></v-divider>
								<v-btn
									small
									@click="handleHireeInfoClick({ hireeInfoId: item.id })"
								>
									view and edit details
									<v-icon right>launch</v-icon>
								</v-btn>
							</fieldset>
						</div>
					</div>

					<!-- Application Steps Section -->
					<div class="application-section steps-section">
						<CandidateApplicationSteps :application="application" />
					</div>
				</div>
			</v-card>
		</div>

		<!-- Dialogs -->
		<ScheduleCandidateDialog
			v-if="isScheduleCandidateDialogVisible"
			:candidateId="candidate.id"
			:onClose="handleScheduleCandidateDialogClose"
			:onSuccess="handleScheduleCandidateDialogSuccess"
		></ScheduleCandidateDialog>
		<EditInterviewDialog
			v-if="editInterviewItem"
			:interview="editInterviewItem"
			:onClose="handleEditInterviewClose"
			:onSuccess="handleEditInterviewSuccess"
		></EditInterviewDialog>
		<v-dialog
			:value="!!cancelInterviewItem"
			max-width="420"
			persistent
		>
			<v-card v-if="cancelInterviewItem">
				<v-card-title class="text-h6">
					{{ $t('button.cancel-interview') }}
				</v-card-title>
				<v-card-text>
					{{ $t('text.cancel-interview-confirmation') }}
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						:disabled="isCancellingInterview"
						@click="handleCancelInterviewClose"
					>
						{{ $t('button.back') }}
					</v-btn>
					<v-btn
						color="error"
						:loading="isCancellingInterview"
						@click="handleCancelInterviewConfirm"
					>
						{{ $t('button.cancel-interview') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<ScheduleEmailDialog
			v-if="isScheduleEmailDialogVisible"
			:email="email"
			:candidate="candidate"
			:onClose="handleScheduleEmailDialogClose"
		></ScheduleEmailDialog>
		<v-dialog v-model="scoreDialog.visible" max-width="480" persistent>
			<v-card>
				<v-card-title class="text-h6">{{ $t('label.run-ai-score') }}</v-card-title>
				<v-card-text>
					<p class="mb-2">{{ $t('label.select-resume-to-score') }}</p>
					<v-radio-group v-if="candidate.files && candidate.files.length" v-model="scoreDialog.selectedFileId" hide-details class="mt-0">
						<v-radio v-for="file in candidate.files" :key="file.id" :value="file.id" :label="file.original_file_name || ('#' + file.id)"></v-radio>
					</v-radio-group>
					<div v-else class="text-caption grey--text">{{ $t('label.no-files-to-score') }}</div>
					<v-alert v-if="scoreDialog.error" type="error" dense text class="mt-3 mb-0">{{ scoreDialog.error }}</v-alert>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="closeScoreDialog" :disabled="scoreDialog.loading">{{ $t('button.cancel') }}</v-btn>
					<v-btn color="primary" :loading="scoreDialog.loading" :disabled="!scoreDialog.selectedFileId" @click="submitScore">{{ $t('label.run-ai-score') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { format } from 'date-fns';
import { toLocaleCapitalize } from '@/utils/helpers';
import Avatar from '@/components/shared/avatar/Avatar';
import CandidateFeedbackIcons from '../../candidateFeedbackIcons/CandidateFeedbackIcons';
import EditApplicationStatus from '../editApplicationStatus/EditApplicationStatus';
import NewJobMenu from './newJobMenu/NewJobMenu';
import EditJobMenu from './editJobMenu/EditJobMenu';
import UserChips from '@/components/shared/userChips/UserChips';
import ScheduleCandidateDialog from '@/components/routes/candidates/scheduleCandidateDialog/ScheduleCandidateDialog';
import EditInterviewDialog from '@/components/routes/candidates/editInterviewDialog/EditInterviewDialog';
import ScheduleEmailDialog from '../emails/scheduleEmailDialog/ScheduleEmailDialog';
import api from '@/api';
import ScheduleEmailMenu from '../emails/scheduleEmailMenu/ScheduleEmailMenu';
import ChipEditor from '@/components/shared/chipEditor/ChipEditor';
import PipelineDurations from '@/components/shared/pipelineDurations/PipelineDurations';
import AdditionalQuestions from './additionalQuestions/AdditionalQuestions';
import CandidateApplicationSteps from '../steps/CandidateApplicationSteps';
import FillPosition from '../fillPosition/FillPosition.vue';
import ProfileEditHistoryDialog from './profileEditHistoryDialog/ProfileEditHistoryDialog';
import { sanitize } from '@/utils/sanitize';

export default {
	name: 'Overview',
	props: {
		candidate: {
			type: Object,
			required: true,
		},
		onArchiveCandidateDialogOpen: {
			type: Function,
			required: true,
		},
		onGoToFeedbacks: {
			type: Function,
			required: true,
		},
	},
	components: {
		Avatar,
		CandidateFeedbackIcons,
		EditApplicationStatus,
		NewJobMenu,
		EditJobMenu,
		UserChips,
		ScheduleCandidateDialog,
		EditInterviewDialog,
		ScheduleEmailDialog,
		ScheduleEmailMenu,
		ChipEditor,
		PipelineDurations,
		AdditionalQuestions,
		CandidateApplicationSteps,
		FillPosition,
		ProfileEditHistoryDialog
	},
	computed: {
		...mapState({
			jobs: state => state.jobs.items,
			tags: state => state.tags.items,
			countries: state => state.geolocations.countries || [],
			currentUser: state => state.currentUser.currentUser,
			currentLang: state => state.currentUser.lang,
			userRole: state => state.currentUser.userRole,
			company: state => state.company.company,
			isDark: state => state.currentUser.isDark,
		}),
		...mapGetters({
			isReadOnlyUser: 'currentUser/isReadOnlyUser',
		}),
		locale() {
			return this.currentLang === 'tr' ? 'tr' : 'en';
		},
		countryName() {
			if (!this.candidate.country_code || !this.countries?.length) {
				return null;
			}
			const country = this.countries.find(c => c.code === this.candidate.country_code);
			return country ? country.name : this.candidate.country_code;
		}
	},
	data() {
		return {
			format,
			toLocaleCapitalize,
			isScheduleCandidateDialogVisible: false,
			isInterviewsCardVisible: false,
			editInterviewItem: null,
			cancelInterviewItem: null,
			isCancellingInterview: false,
			showMore: false,
			isScheduleEmailDialogVisible: false,
			email: null,
			scoreDialog: {
				visible: false,
				application: null,
				selectedFileId: null,
				loading: false,
				error: null,
			},
			profileEditHistory: {
				education: [],
				work_experience: [],
			},
			editHistoryDialog: {
				visible: false,
				section: null,
			},
		};
	},
	async mounted() {
		await this.$store.dispatch('geolocations/getCountries', { updateStore: true });
		this.initializeApplicationBreakdowns();
		this.fetchProfileEditHistory();
	},
	watch: {
		// The prop is replaced with a fresh object after every save/refresh,
		// so this also picks up history created by an edit just made.
		candidate: function (newVal, oldVal) {
			if (!newVal) {
				return;
			}
			if (oldVal && newVal.id !== oldVal.id) {
				this.profileEditHistory = { education: [], work_experience: [] };
			}
			this.fetchProfileEditHistory();
		},
	},
	methods: {
		sanitize,
		fetchProfileEditHistory() {
			const candidateId = this.candidate && this.candidate.id;
			if (!candidateId) {
				return;
			}
			api.activities
				.get({ candidate_id: candidateId })
				.then(response => {
					const items = (response.data && response.data.items) || [];
					const parseRows = value => {
						try {
							const parsed = JSON.parse(value);
							return Array.isArray(parsed) ? parsed : [];
						} catch (error) {
							return [];
						}
					};
					const byCode = code =>
						items
							.filter(item => item.activity_code === code)
							.map(item => ({
								...item,
								oldRows: parseRows(item.old_val),
								newRows: parseRows(item.new_val),
							}));
					this.profileEditHistory = {
						education: byCode('candidate_education_updated_by_user'),
						work_experience: byCode(
							'candidate_work_experience_updated_by_user',
						),
					};
				})
				.catch(() => {
					// history is informative only; never block the overview
				});
		},
		openEditHistory(section) {
			this.editHistoryDialog = { visible: true, section };
		},
		closeEditHistory() {
			this.editHistoryDialog = { visible: false, section: null };
		},
		initializeApplicationBreakdowns() {
			if (this.candidate.applications) {
				this.candidate.applications.forEach(app => {
					this.$set(app, 'showBreakdown', false);
					this.$set(app, 'showFullCoverLetter', false);
				});
			}
		},
		toggleScoreBreakdown(applicationId) {
			const application = this.candidate.applications.find(app => app.id === applicationId);
			if (application) {
				this.$set(application, 'showBreakdown', !application.showBreakdown);
			}
		},
		openScoreDialog(application) {
			const files = this.candidate.files || [];
			this.scoreDialog = {
				visible: true,
				application,
				selectedFileId: files.length === 1 ? files[0].id : null,
				loading: false,
				error: null,
			};
		},
		closeScoreDialog() {
			this.scoreDialog.visible = false;
		},
		async submitScore() {
			const { application, selectedFileId } = this.scoreDialog;
			if (!application || !selectedFileId) return;
			this.scoreDialog.loading = true;
			this.scoreDialog.error = null;
			try {
				const { data } = await api.candidates.applications.score({
					application_id: application.id,
					resume_id: selectedFileId,
				});
				this.$set(application, 'ai_score', data.score);
				this.$set(application, 'ai_score_breakdown', data.breakdown);
				this.$set(application, 'showBreakdown', false);
				this.scoreDialog.visible = false;
			} catch (error) {
				const status = error && error.response && error.response.status;
				this.scoreDialog.error = status === 404 ? this.$t('label.score-resume-not-parsed') : this.$t('label.score-failed');
			} finally {
				this.scoreDialog.loading = false;
			}
		},
		toggleCoverLetter(applicationId) {
			const application = this.candidate.applications.find(app => app.id === applicationId);
			if (application) {
				this.$set(application, 'showFullCoverLetter', !application.showFullCoverLetter);
			}
		},
		getScoreColor(score) {
			if (score >= 80) return 'success';   // Green - Excellent
			if (score >= 60) return 'info';      // Blue/Cyan - Good
			if (score >= 40) return 'warning';   // Yellow/Amber - Fair
			return 'error';                       // Red - Poor
		},
		getScoreClass(score) {
			if (score >= 80) return 'score-excellent';
			if (score >= 60) return 'score-good';
			if (score >= 40) return 'score-fair';
			return 'score-poor';
		},
		getScoreColorHex(score) {
			if (score >= 80) return '#155724';   // Dark green
			if (score >= 60) return '#0c5460';   // Dark cyan/teal
			if (score >= 40) return '#856404';   // Dark amber
			return '#721c24';                     // Dark red
		},
		getScoreQuality(score) {
			if (score >= 80) return this.$t('label.excellent-match') || 'Excellent';
			if (score >= 60) return this.$t('label.good-match') || 'Good';
			if (score >= 40) return this.$t('label.fair-match') || 'Fair';
			return this.$t('label.poor-match') || 'Needs Review';
		},
		getCategoryIcon(key) {
			const icons = {
				skills_match: 'construction',
				experience_relevance: 'work_history',
				education_fit: 'school',
				profile_quality: 'person',
			};
			return icons[key] || 'check_circle';
		},
		getLocalizedReasoning(reasoning) {
			const lang = this.currentLang === 'tr' ? 'tr' : 'en';
			return reasoning[lang];
		},
		formatCategoryName(key) {
			const categoryNames = {
				skills_match: this.$t('label.skills-match') || 'Skills Match',
				experience_relevance: this.$t('label.experience-relevance') || 'Experience Relevance',
				education_fit: this.$t('label.education-fit') || 'Education Fit',
				profile_quality: this.$t('label.profile-quality') || 'Profile Quality',
			};
			return categoryNames[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
		},
		getJobName({ jobId }) {
			const { jobs } = this;
			const job = jobs.find(item => item.id === jobId);
			return job ? job.name : jobId;
		},
		handleGetApplicationStatus({
			is_interview,
			interview_status,
			is_lead,
			lead_status,
			is_archived,
			archive_status,
		}) {
			if (is_archived) {
				return archive_status ? archive_status : 'underqualified';
			} else if (is_interview) {
				return interview_status ? interview_status : 'phone';
			} else if (is_lead) {
				return lead_status ? lead_status : 'new-lead';
			}
			return 'new-applicant';
		},
		handleApplicationStatusChange() {
			this.$store.commit('candidates/setItemNeedsToRefresh');
			this.$store.commit('candidates/setItemsNeedToRefresh');
		},
		formatDate({ timestamp = new Date(), format = 'dd.MM.yyyy HH:mm:ss' }) {
			const dateToFormat = new Date(timestamp);
			return this.format(dateToFormat, format);
		},
		handleScheduleCandidateDialogOpen() {
			this.isScheduleCandidateDialogVisible = true;
		},
		handleScheduleCandidateDialogClose() {
			this.isScheduleCandidateDialogVisible = false;
		},
		handleScheduleCandidateDialogSuccess() {
			this.isScheduleCandidateDialogVisible = false;
			this.$store.commit('candidates/setItemNeedsToRefresh');
		},
		handleToggleInterviews() {
			this.isInterviewsCardVisible = !this.isInterviewsCardVisible;
		},
		isInterviewCancelled(item) {
			return item.status === 'cancelled';
		},
		canManageInterview(item) {
			const isOrganizer =
				this.currentUser && this.currentUser.id === item.organizer_id;
			const isAdmin = this.userRole >= 666;
			return isOrganizer || isAdmin;
		},
		handleEditInterviewOpen({ item }) {
			this.editInterviewItem = item;
		},
		handleEditInterviewClose() {
			this.editInterviewItem = null;
		},
		handleEditInterviewSuccess() {
			this.editInterviewItem = null;
			this.$store.commit('candidates/setItemNeedsToRefresh');
		},
		handleCancelInterviewOpen({ item }) {
			this.cancelInterviewItem = item;
		},
		handleCancelInterviewClose() {
			this.cancelInterviewItem = null;
		},
		handleCancelInterviewConfirm() {
			this.isCancellingInterview = true;
			api.events
				.delete({ id: this.cancelInterviewItem.id })
				.then(() => {
					this.isCancellingInterview = false;
					this.cancelInterviewItem = null;
					this.$store.commit('candidates/setItemNeedsToRefresh');
				})
				.catch(() => {
					this.isCancellingInterview = false;
				});
		},
		handleScheduleNewEmail({ email }) {
			this.email = email;
			this.isScheduleEmailDialogVisible = true;
		},
		handleScheduleEmailDialogClose() {
			this.isScheduleEmailDialogVisible = false;
		},
		handleTogglePipelineDurations({ application_id }) {
			this.candidate = {
				...this.candidate,
				applications: this.candidate.applications.map(applicationItem => {
					if (applicationItem.id === application_id) {
						return {
							...applicationItem,
							is_pipeline_durations_visible:
								!applicationItem.is_pipeline_durations_visible,
						};
					}
					return {
						...applicationItem,
					};
				}),
			};
		},
		handleSendOfferClick() {
			const { id } = this.candidate;
			const { currentLang } = this;
			const { query } = this.$route;
			this.$router.push({
				path: `/${currentLang}/candidates/edit/${id}/requisitions/new`,
				query,
			});
		},
		handleHireeInfoClick({ hireeInfoId }) {
			const { id } = this.candidate;
			const { currentLang } = this;
			const { query } = this.$route;
			this.$router.push({
				path: `/${currentLang}/candidates/edit/${id}/hiree-info/${hireeInfoId}`,
				query,
			});
		},
	},
};
</script>

<style scoped>
/* ========================================
   Base Container
   ======================================== */
.overview-container {
	padding: 0;
}

/* ========================================
   Candidate Info Section
   ======================================== */
.candidate-info-section {
	margin-bottom: 16px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.theme--dark .candidate-info-section {
	border-bottom-color: rgba(255, 255, 255, 0.08);
}

.candidate-info-list {
	padding: 0;
}

/* ========================================
   Action Buttons Section
   ======================================== */
.action-buttons-section {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 16px 0;
	border-bottom: 1px solid rgba(0, 0, 0, 0.08);
	margin-bottom: 24px;
}

.theme--dark .action-buttons-section {
	border-bottom-color: rgba(255, 255, 255, 0.08);
}

.action-btn {
	margin: 0 !important;
}

/* ========================================
   Applications Section Header
   ======================================== */
.applications-section-header {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 0;
	margin-bottom: 16px;
}

.section-header-icon {
	color: rgba(0, 0, 0, 0.54);
}

.theme--dark .section-header-icon {
	color: rgba(255, 255, 255, 0.54);
}

.section-header-title {
	font-size: 1rem;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.87);
}

.theme--dark .section-header-title {
	color: rgba(255, 255, 255, 0.87);
}

.section-header-count {
	font-size: 0.875rem;
	color: rgba(0, 0, 0, 0.54);
}

.theme--dark .section-header-count {
	color: rgba(255, 255, 255, 0.54);
}

/* ========================================
   Application Cards
   ======================================== */
.applications-list {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.application-card {
	border-radius: 8px !important;
	overflow: hidden;
	transition: box-shadow 0.2s ease;
}

.application-card:hover {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.theme--dark .application-card:hover {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;
}

/* ========================================
   Application Card Header
   ======================================== */
.application-card-header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 16px;
	background-color: rgba(0, 0, 0, 0.02);
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.theme--dark .application-card-header {
	background-color: rgba(255, 255, 255, 0.02);
	border-bottom-color: rgba(255, 255, 255, 0.06);
}

.application-card-header-left {
	display: flex;
	gap: 12px;
	flex: 1;
	min-width: 0;
}

.application-card-header-right {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
}

/* Fill Position Button in header */
.fill-position-header {
	display: flex;
	align-items: center;
}

.fill-position-header >>> .v-btn,
.fill-position-header ::v-deep .v-btn {
	text-transform: none !important;
	font-weight: 500;
	letter-spacing: 0;
}

.application-avatar {
	flex-shrink: 0;
}

.application-title-section {
	flex: 1;
	min-width: 0;
}

.application-title-row {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.application-job-title {
	font-size: 1.1rem;
	font-weight: 600;
	margin: 0;
	color: rgba(0, 0, 0, 0.87);
	line-height: 1.3;
}

.theme--dark .application-job-title {
	color: rgba(255, 255, 255, 0.87);
}

.application-legacy-score {
	font-weight: 400;
	color: rgba(0, 0, 0, 0.54);
}

.theme--dark .application-legacy-score {
	color: rgba(255, 255, 255, 0.54);
}

/* ========================================
   Application Meta
   ======================================== */
.application-meta {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 4px 16px;
	margin-top: 8px;
}

.meta-item {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 0.8125rem;
	color: rgba(0, 0, 0, 0.6);
}

.theme--dark .meta-item {
	color: rgba(255, 255, 255, 0.6);
}

.meta-icon {
	font-size: 14px !important;
	opacity: 0.7;
}

.meta-identifier {
	font-family: 'Roboto Mono', monospace;
	background-color: rgba(0, 0, 0, 0.04);
	padding: 2px 6px;
	border-radius: 4px;
}

.theme--dark .meta-identifier {
	background-color: rgba(255, 255, 255, 0.08);
}

/* ========================================
   Application Card Body
   ======================================== */
.application-card-body {
	padding: 16px;
}

.application-section {
	padding: 12px 0;
}

.application-section:first-child {
	padding-top: 0;
}

.application-section:last-child {
	padding-bottom: 0;
}

/* No automatic borders - we'll add them explicitly where needed */

.section-label {
	font-size: 0.75rem;
	font-weight: 500;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	color: rgba(0, 0, 0, 0.54);
	margin-bottom: 8px;
}

.theme--dark .section-label {
	color: rgba(255, 255, 255, 0.54);
}

.section-subheader {
	font-size: 0.8125rem;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.7);
	margin-bottom: 12px;
}

.theme--dark .section-subheader {
	color: rgba(255, 255, 255, 0.7);
}

/* ========================================
   AI Score Section - Option D (Compact Chip)
   ======================================== */
.ai-score-section {
	/* Uses standard section styling */
}

.ai-score-compact {
	display: inline-flex;
	align-items: center;
	gap: 8px;
}

.ai-score-chip {
	font-weight: 600;
}

.ai-score-info {
	color: rgba(0, 0, 0, 0.4);
	cursor: help;
}

.theme--dark .ai-score-info {
	color: rgba(255, 255, 255, 0.4);
}

.ai-score-toggle {
	text-transform: none !important;
	margin-left: 4px;
}

/* Score color classes - matching ApplicationCell.vue */
.score-excellent { 
	background: #d4edda; 
	color: #155724; 
}

.score-good { 
	background: #d1ecf1; 
	color: #0c5460; 
}

.score-fair { 
	background: #fff3cd; 
	color: #856404; 
}

.score-poor { 
	background: #f8d7da; 
	color: #721c24; 
}

/* Dark theme score colors */
.theme--dark .score-excellent {
	background: rgba(76, 175, 80, 0.3);
	color: #a5d6a7;
}

.theme--dark .score-good {
	background: rgba(33, 150, 243, 0.3);
	color: #90caf9;
}

.theme--dark .score-fair {
	background: rgba(255, 193, 7, 0.3);
	color: #ffe082;
}

.theme--dark .score-poor {
	background: rgba(244, 67, 54, 0.3);
	color: #ef9a9a;
}

/* Breakdown styles */
.ai-score-breakdown-compact {
	margin-top: 16px;
	padding-top: 16px;
	border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.theme--dark .ai-score-breakdown-compact {
	border-top-color: rgba(255, 255, 255, 0.08);
}

.breakdown-row {
	margin-bottom: 16px;
}

.breakdown-row:last-of-type {
	margin-bottom: 12px;
}

.breakdown-row-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 4px;
}

.breakdown-row-name {
	font-size: 0.8125rem;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.8);
}

.theme--dark .breakdown-row-name {
	color: rgba(255, 255, 255, 0.8);
}

.breakdown-row-score {
	font-size: 0.8125rem;
	font-weight: 600;
	padding: 1px 6px;
	border-radius: 3px;
}

.breakdown-row-progress {
	margin-bottom: 4px;
}

.breakdown-row-reasoning {
	font-size: 0.75rem;
	color: rgba(0, 0, 0, 0.54);
	line-height: 1.4;
}

.theme--dark .breakdown-row-reasoning {
	color: rgba(255, 255, 255, 0.54);
}

.breakdown-footer-compact {
	display: flex;
	align-items: center;
	font-size: 0.7rem;
	color: rgba(0, 0, 0, 0.45);
	font-style: italic;
	padding-top: 8px;
	border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.theme--dark .breakdown-footer-compact {
	color: rgba(255, 255, 255, 0.45);
	border-top-color: rgba(255, 255, 255, 0.06);
}

/* ========================================
   Feedbacks Section
   ======================================== */
.feedbacks-section .feedbacks-content {
	cursor: pointer;
}

/* ========================================
   Cover Letter Section
   ======================================== */
.cover-letter-wrapper {
	background-color: rgba(33, 150, 243, 0.04);
	border: 1px solid rgba(33, 150, 243, 0.2);
	border-radius: 6px;
	padding: 12px 16px;
	position: relative;
}

.theme--dark .cover-letter-wrapper {
	background-color: rgba(33, 150, 243, 0.08);
	border-color: rgba(33, 150, 243, 0.3);
}

.cover-letter-content {
	font-size: 0.875rem;
	line-height: 1.6;
	color: rgba(0, 0, 0, 0.8);
}

.theme--dark .cover-letter-content {
	color: rgba(255, 255, 255, 0.8);
}

.cover-letter-collapsed {
	max-height: 4.8em; /* approximately 3 lines */
	overflow: hidden;
	position: relative;
}

.cover-letter-collapsed::after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	height: 2em;
	background: linear-gradient(transparent, rgba(33, 150, 243, 0.04));
}

.theme--dark .cover-letter-collapsed::after {
	background: linear-gradient(transparent, rgba(33, 150, 243, 0.08));
}

.cover-letter-toggle {
	margin-top: 4px;
	text-align: left;
}

.cover-letter-toggle .v-btn {
	text-transform: none;
	padding: 0 8px;
	margin-left: -8px;
}

/* ========================================
   Section Divider
   ======================================== */
.section-divider {
	margin-bottom: 16px;
}

/* ========================================
   Questions Section - override AdditionalQuestions component styling
   ======================================== */
.questions-content {
	/* Hide the internal headers from AdditionalQuestions component */
}

.questions-content >>> .v-subheader,
.questions-content ::v-deep .v-subheader {
	font-size: 0.8125rem !important;
	font-weight: 500 !important;
	color: rgba(0, 0, 0, 0.7) !important;
	padding-left: 0 !important;
	height: auto !important;
	margin-top: 16px;
	margin-bottom: 8px;
}

.theme--dark .questions-content >>> .v-subheader,
.theme--dark .questions-content ::v-deep .v-subheader {
	color: rgba(255, 255, 255, 0.7) !important;
}

/* ========================================
   Interviews Section
   ======================================== */
.interviews-toggle-btn {
	text-transform: none;
}

.interviews-card {
	margin-top: 12px;
	padding: 12px;
	background-color: rgba(0, 0, 0, 0.02) !important;
}

.theme--dark .interviews-card {
	background-color: rgba(255, 255, 255, 0.03) !important;
}

.interview-item {
	padding: 8px 0;
}

.interview-item--cancelled .interview-datetime strong,
.interview-item--cancelled .interview-summary {
	text-decoration: line-through;
	opacity: 0.55;
}

.interview-actions {
	white-space: nowrap;
}

.interview-item:first-child {
	padding-top: 0;
}

.interview-item:last-child {
	padding-bottom: 0;
}

.interview-datetime {
	font-size: 0.875rem;
}

.interview-summary {
	font-size: 0.875rem;
	color: rgba(0, 0, 0, 0.7);
	margin-top: 4px;
}

.theme--dark .interview-summary {
	color: rgba(255, 255, 255, 0.7);
}

.interview-interviewers {
	margin-top: 8px;
}

.interview-divider {
	margin: 12px 0;
}

/* ========================================
   Hired Info Section
   ======================================== */
.hired-info-label {
	font-size: 12px;
}

.hired-info-value {
	font-size: 0.875rem;
	margin-top: 4px;
}

/* ========================================
   Steps Section
   ======================================== */
.steps-section {
	border-top: none !important;
	padding-top: 16px !important;
}

/* ========================================
   Responsive Adjustments
   ======================================== */
@media (max-width: 600px) {
	.application-card-header {
		flex-direction: column;
		gap: 12px;
	}

	.application-card-header-right {
		align-self: flex-start;
	}

	.application-meta {
		flex-direction: column;
		align-items: flex-start;
		gap: 4px;
	}
}
</style>